import classNames from "classnames";
import { computed, IComputedValue } from "mobx";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { Pane, PaneViewMode } from "../Types";
import { PaneComponentContext } from "./PaneComponentContext";
import { PANE_HEADER_BAR_HEIGHT } from "./SandboxConstants";
import { PANE_BODY_CLASSNAME } from "./SandboxUtils";

export const PaneBody = observer(
  ({
    viewMode,
    paneComputed,
    children,
  }: {
    viewMode: PaneViewMode;
    paneComputed: IComputedValue<Pane | undefined>;
    children: React.ReactNode;
  }) => {
    const { showPaneBodyOnCollapsedPaneBox } = useContext(PaneComponentContext);

    const collapsePreviewBodyStyle = computed(() => {
      if (viewMode !== PaneViewMode.Collapsed) {
        return undefined;
      }
      const rect = paneComputed.get()?.rect;
      if (rect === undefined) {
        return undefined;
      }
      return {
        width: `${rect[2] + 1}px`,
        height: `${rect[3] - PANE_HEADER_BAR_HEIGHT}px`,
      };
    }).get();

    return (
      <>
        {viewMode === PaneViewMode.Collapsed &&
        showPaneBodyOnCollapsedPaneBox.get() ? (
          <div className="absolute top-full left-0 w-full h-2" />
        ) : null}
        <div
          className={classNames(
            PANE_BODY_CLASSNAME,
            "flex flex-col grow overflow-hidden bg-neutral-0 rounded-b z-1",
            viewMode === PaneViewMode.Collapsed
              ? showPaneBodyOnCollapsedPaneBox.get()
                ? "absolute rounded-t top-full mt-2 block shadow-pane animate-fade-in"
                : "hidden"
              : "relative"
          )}
          style={collapsePreviewBodyStyle}
        >
          {children}
        </div>
      </>
    );
  }
);
